import React from 'react';
import { Modal } from 'react-bootstrap';

import GearModelList2Container from '../containers/GearModelList2Container.jsx';
import GearModelEditContainer from '../containers/GearModelEditContainer.jsx';
import GearModelsUploadContainer from '../containers/GearModelsUploadContainer.jsx';

export default class GearModelsComponent extends React.Component {

	componentDidMount() {
	}

	render() {
		return (
			<div>
				<h4>消防衣型號/洗標模板管理</h4>
				<GearModelList2Container />
				<Modal show={this.props.showModal} onHide={this.props.closeModal} backdrop="static">
					<Modal.Header closeButton />
					<Modal.Body>
						<GearModelEditContainer />
					</Modal.Body>
				</Modal>
				<Modal show={this.props.showUploadModal} onHide={this.props.closeModal} backdrop="static">
					<Modal.Header closeButton />
					<Modal.Body>
						<GearModelsUploadContainer />
					</Modal.Body>
				</Modal>
			</div>
		)
	}
}


// WEBPACK FOOTER //
// ./src/components/GearModelsComponent.jsx